import * as React from 'react'
import { SVGProps } from 'react'
const SvgInfoFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width={23} height={23} viewBox="0 0 23 23" fill="#146c92" {...props}>
    <circle cx={11.5} cy={11.5} r={11.5} fill="var(--info)" />
    <path
      d="M13.902 17H9.273v-.535c.127-.01.252-.022.374-.036.122-.015.227-.04.315-.073a.613.613 0 0 0 .33-.25.888.888 0 0 0 .095-.439v-4.263c0-.17-.04-.32-.117-.447a.957.957 0 0 0-.293-.314 1.552 1.552 0 0 0-.403-.169 2.528 2.528 0 0 0-.484-.102v-.535l3.59-.19.11.11v5.815c0 .17.036.317.109.44a.672.672 0 0 0 .315.263c.098.044.205.083.322.117.117.034.24.059.366.073V17Zm-1.069-9.99c0 .37-.144.688-.432.952-.283.259-.62.388-1.01.388-.396 0-.738-.13-1.026-.388a1.255 1.255 0 0 1-.425-.952c0-.371.142-.689.425-.952.288-.264.63-.396 1.025-.396.396 0 .735.132 1.018.396.283.263.425.58.425.952Z"
      fill="#fff"
    />
  </svg>
)
export default SvgInfoFilled
